<template>
  <div class="account-page scrollable">
    <div class="page-header">
      <h1>Create Manual Tinder Scan</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/manual-tinder-scans' }">Manual Tinder Scans</el-breadcrumb-item>
        <el-breadcrumb-item>Create</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card>
      <el-form :model="form" :rules="rules" ref="scanForm" label-width="160px" v-loading="submitting">

        <el-form-item label="User" prop="user_id">
          <el-select
            v-model="form.user_id"
            filterable
            remote
            reserve-keyword
            placeholder="Start typing user email..."
            :remote-method="searchUsers"
            :loading="usersLoading"
            style="width: 100%;"
          >
            <el-option
              v-for="user in userOptions"
              :key="user.id"
              :label="user.email"
              :value="user.id"
            >
              <span>{{ user.email }}</span>
              <span style="float: right; color: #8492a6; font-size: 12px;">ID: {{ user.id }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Partner's Name" prop="name">
          <el-input v-model="form.name" placeholder="Name to search for"></el-input>
        </el-form-item>

        <el-form-item label="Partner's Email" prop="email">
          <el-input v-model="form.email" placeholder="Partner's email"></el-input>
        </el-form-item>

        <el-form-item label="Gender" prop="gender">
          <el-select v-model="form.gender" placeholder="Select gender" style="width: 100%;">
            <el-option label="Male" :value="0"></el-option>
            <el-option label="Female" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Min Age" prop="min_age">
          <el-input-number v-model="form.min_age" :min="18" :max="99" style="width: 100%;"></el-input-number>
        </el-form-item>

        <el-form-item label="Max Age" prop="max_age">
          <el-input-number v-model="form.max_age" :min="18" :max="99" style="width: 100%;"></el-input-number>
        </el-form-item>

        <el-form-item label="Location" prop="location_address">
          <GmapAutocomplete
            class="el-input__inner"
            placeholder="Address, City, State, or click on the map"
            @place_changed="setPlace"
            ref="addressInput"
            style="width: 100%;"
          />
        </el-form-item>

        <el-form-item label="">
          <GmapMap
            :center="mapOptions.center"
            :zoom="mapOptions.zoom"
            style="width: 100%; height: 300px;"
            @click="onMapClick"
          >
            <GmapMarker
              v-if="marker"
              :position="marker"
              :clickable="true"
              :draggable="true"
              @dragend="onMarkerDrag"
            />
          </GmapMap>
        </el-form-item>

        <el-form-item label="Location Address" prop="location_address">
          <el-input v-model="form.location_address" placeholder="e.g. New York, NY, USA"></el-input>
        </el-form-item>

        <el-form-item label="Latitude" prop="lat">
          <el-input v-model="form.lat" placeholder="e.g. 40.7128"></el-input>
        </el-form-item>

        <el-form-item label="Longitude" prop="lng">
          <el-input v-model="form.lng" placeholder="e.g. -74.0060"></el-input>
        </el-form-item>

        <el-form-item label="Radius (miles)" prop="radius">
          <el-input-number v-model="form.radius" :min="1" :max="100" style="width: 100%;"></el-input-number>
        </el-form-item>

        <el-form-item label="Repeatable" prop="repeatable">
          <el-checkbox v-model="form.repeatable">Re-scan every ~90 minutes</el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm(false)" :loading="submitting">Create & Launch Scan</el-button>
          <el-button type="success" @click="submitForm(true)" :loading="submitting">Create Recent-Only Scan</el-button>
          <el-button @click="$router.push('/manual-tinder-scans')">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { createManualTinderScan } from '../../api/manualTinderScansApi'
import { getUsers } from '../../api/users'

export default {
  name: 'ManualTinderScanCreate',
  data() {
    return {
      form: {
        user_id: null,
        name: '',
        email: '',
        gender: null,
        min_age: 18,
        max_age: 30,
        location_address: '',
        lat: '',
        lng: '',
        radius: 30,
        repeatable: false,
      },
      mapOptions: {
        center: { lat: 40.7145, lng: -74.0094 },
        zoom: 10,
      },
      marker: null,
      rules: {
        user_id: [{ required: true, message: 'Please select a user', trigger: 'change' }],
        name: [{ required: true, message: 'Name is required', trigger: 'blur' }],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid email', trigger: 'blur' }
        ],
        gender: [{ required: true, message: 'Please select gender', trigger: 'change' }],
        min_age: [{ required: true, message: 'Min age is required', trigger: 'change' }],
        location_address: [{ required: true, message: 'Location is required', trigger: 'blur' }],
        lat: [{ required: true, message: 'Latitude is required', trigger: 'blur' }],
        lng: [{ required: true, message: 'Longitude is required', trigger: 'blur' }],
        radius: [{ required: true, message: 'Radius is required', trigger: 'change' }],
      },
      userOptions: [],
      usersLoading: false,
      submitting: false,
    }
  },
  methods: {
    setPlace(place) {
      this.marker = place.geometry.location
      this.mapOptions.center = place.geometry.location
      this.form.lat = place.geometry.location.lat()
      this.form.lng = place.geometry.location.lng()
      this.form.location_address = place.formatted_address
    },
    onMapClick(e) {
      this.marker = e.latLng
      this.form.lat = e.latLng.lat()
      this.form.lng = e.latLng.lng()
      this.form.location_address = `${e.latLng.lat().toFixed(6)}, ${e.latLng.lng().toFixed(6)}`
      if (this.$refs.addressInput) {
        this.$refs.addressInput.$el.value = this.form.location_address
      }
    },
    onMarkerDrag(e) {
      this.marker = e.latLng
      this.form.lat = e.latLng.lat()
      this.form.lng = e.latLng.lng()
      this.form.location_address = `${e.latLng.lat().toFixed(6)}, ${e.latLng.lng().toFixed(6)}`
      if (this.$refs.addressInput) {
        this.$refs.addressInput.$el.value = this.form.location_address
      }
    },
    async searchUsers(query) {
      if (query.length < 2) {
        this.userOptions = []
        return
      }
      this.usersLoading = true
      try {
        const params = `filter=${encodeURIComponent(query)}&per_page=20`
        const res = await getUsers(params)
        this.userOptions = res.data || []
      } catch (e) {
        this.userOptions = []
      }
      this.usersLoading = false
    },
    submitForm(freshOnly = false) {
      this.$refs.scanForm.validate(async (valid) => {
        if (!valid) return

        this.submitting = true
        try {
          const data = { ...this.form, recent_only: freshOnly }
          if (!data.max_age || data.max_age < data.min_age) {
            data.max_age = null
          }
          await createManualTinderScan(data)
          this.$message.success('Manual scan created and launched successfully!')
          this.$router.push('/manual-tinder-scans')
        } catch (e) {
          const msg = e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : 'Failed to create scan'
          this.$message.error(msg)
        }
        this.submitting = false
      })
    }
  }
}
</script>

<style scoped>
.el-card {
  max-width: 700px;
}
</style>
